import React from 'react';
import { Link } from 'react-router';

import { onEnquireClick } from '../../common/onEnquireClick';
import getPpsUrl from '../../common/ppsUrl';

const LandSearchGridItem = (props) => {
	const ppsUrl = getPpsUrl(props.data.pps_url);
	let lotFrontage = '';
    let lotStatus = <span className="fcolor-gr">Now Selling</span>;
    if(props.data.status === 2) {
        lotStatus = <span className="fcolor-gray">Sold</span>;
    }
    if(props.data.status === 3) {
        lotStatus = <span className="fcolor-bl">Builder Excl.</span>;
    }
	if(props.data.status === 6) {
		lotStatus = <span className="fcolor-bl">Coming Soon</span>;
	}

	let formattedprice ="" ;
	if(props.data.price !== null) {
		let price = parseInt(props.data.price);
		formattedprice = "$" + price.toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1,');

	}

	switch(props.data.type) {
		case 'Irregular Lot':
			lotFrontage = 'Irregular';
			break;
		case 'Corner Lot':
			lotFrontage = 'Corner';
			break;
		default:
			lotFrontage = props.data.frontage + 'm';
	}

    return (

            <div className="w-100 w-50-md w-33-lg w-25-wd fl p-a-1-md p-b-1">

                <Link to={props.data.link}>
                    <img className="select-package-image" src={props.data.image} alt=""/>
                </Link>


                <div className="river-select-package-text">
                    <div className="cf m-b-05 m-t-05 tc tl-md">
						<div className="fl w-50 tl">
							<Link to={props.data.link}>
								<p className="select-package-header small-blue-font m-b-1">Lot {props.data.name} - {lotStatus}</p>
							</Link>
						</div>


						<div className="fr w-50 tr">
							<p className="small-grey-font">{formattedprice}</p>
						</div>

                    </div>

                    <div className="cf m-b-05">
                        <div className="fl w-50 tl">
                            <p className="small-grey-font fcolor-og">{props.data.stage}</p>
                        </div>

                                    <div className="fr w-50 tr">
                                        <p className="small-grey-font">{props.data.package_count} Packages</p>
                                    </div>
                                </div>

                                <div className="cf p-b-1 m-b-1 brd-bottom">

                    <div className="fl w-50 tl">
                        <p className="small-grey-font">Land Size<span className="fcolor-og small-grey-font"> {props.data.area}m<sup>2</sup></span></p>
                    </div>

                    <div className="fr w-50 tr">
                        <p className="small-grey-font">Frontage<span className="fcolor-og small-grey-font"> {lotFrontage}</span></p>
                    </div>
                </div>

                <div className="cf m-b-05">
                    <div className="fl w-50 select-package-download-icon">
                        <a className="download-flyer" href={props.data.pdf} target="_blank">
                            <i className="icon icon--download-alt"></i>
                            <span className="small-grey-font">Download Flyer</span>
                        </a>
                        {ppsUrl ? (
                            <a className="download-flyer pps-card-download" href={ppsUrl} target="_blank" rel="noopener noreferrer">
                                <i className="icon icon--download-alt"></i>
                                <span className="small-grey-font">Download PPS</span>
                            </a>
                        ) : (
                            <span className="download-flyer pps-card-download pps-card-download-spacer" aria-hidden="true"></span>
                        )}
                    </div>

                    <div className="fr w-50">
                        <a className="btn btn__enquire js-registrationModal fr" onClick={(ev) => onEnquireClick(ev, "", "", props.data.name)}>
                            <span className="btn-land-available">ENQUIRE</span>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default LandSearchGridItem;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/LandSearchGridItem.js
 **/